<!--
 * @Description: 查看项目人员列表, 分配任务量，修改任务数，邀请置灰根据缓存中的 currentPerojectPersonnelCsoStatus判断
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <div class="project-personnel-inside-list">
    <div class="project-personnel-inside-list__tip">{{ projectTypeName }}</div>
    <table-render
      :key="tableKey"
      size="small"
      style="padding-top:50px"
      ref="tableRender"
      rowKey="userId"
      @select="selected => (selection = selected)"
      @select-all="selected => (selection = selected)"
      :config="config"
      :propData="tableQuery"
      :rowClassName="
        ({ row, rowIndex }) =>
          getUnqualifiedRowConfig({
            row: row,
            rowIndex: rowIndex,
            isNotUnqualified: isNotUnqualified(row)
          })
      "
    >
      <template slot="top-alert">
        <el-row type="flex" justify="space-between" class="pb10" align="middle">
          <div>已选{{ selection.length }}项</div>
          <div>
            往期人员：
            <el-switch
              v-model="isNowExecute"
              active-text="显示"
              :active-value="1"
              inactive-text="不显示"
              :inactive-value="0"
            ></el-switch>
          </div>
        </el-row>
      </template>
    </table-render>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import mainMap from './config';
import { judge } from '@/Mixin/judge';
import hasIndustry from '@/Mixin/hasIndustry';
import { deepClone } from '@/tools';
import { getUnqualifiedRowConfig } from '@/methods/unqualified';
import { BANK_MAPPING } from '@/common/constants/bank';
import { certification } from '@/api/ajax';
import { Message } from 'element-ui';

export default {
  name: 'ProjectPersonnelInsideList',
  mixins: [judge, hasIndustry],
  inject: ['forceReload'],
  provide() {
    return {
      _parent: this // 把当前实例传递给后续弹层使用
    };
  },
  data() {
    return {
      tableKey: 1,
      getUnqualifiedRowConfig,
      // 是否显示往期人员 0 不显示  1 显示
      isNowExecute: 0,
      config: null,
      propData: {},
      nextMonthAddStatus: -1,
      selection: [],
      messages: {}
    };
  },
  watch: {
    isNowExecute: {
      handler: async function() {
        await this.$store.dispatch('syncProjectInfo');
        this.$refs.tableRender.init();
      },
      immediate: false
    }
  },
  components: { tableRender },
  computed: {
    BANK_MAPPING() {
      return this.$store.state.bank.banks;
    },
    projectTypeName() {
      return this.$store.state.homeProject.projectTypeName;
    },
    tableQuery() {
      return {
        query: {
          ...this.propData.query,
          isNowExecute: this.isNowExecute
        }
      };
    }
  },
  methods: {
    isNotUnqualified(row) {
      return !(
        ('superviseStatus' in row && row.superviseStatus === 3) ||
        row.zbBlackStatus === 2
      );
    },
    createMsg(key, msg) {
      console.log(this);
      if (!this.messages || this.messages[key]) return;
      if (+localStorage.getItem(key) !== 1) {
        this.messages[key] = Message({
          showClose: true,
          message: msg,
          type: 'warning',
          duration: 0,
          customClass: 'project-personnel-inside-list__message',
          onClose: e => {
            !e.autoClose && localStorage.setItem(key, 1);
          }
        });
      }
    },
    ossRejectMsg() {
      this.createMsg(
        '_tipOne',
        '本项目执行人需进行资质审核，请前往项目入驻模块进行审核'
      );
    },
    needCertificationMsg(count) {
      this.createMsg(
        '_tipTwo',
        `本项目执行人需进行资质审核，请前往项目入驻模块进行审核，${count}个项目人员资质平台审核未通过，执行人修改资质后需再次审核`
      );
    }
  },
  async created() {
    let {
      id,
      type,
      projectStructureType,
      projectType
    } = this.$store.state.homeProject;

    this.propData.query = {
      type,
      projectId: id,
      taskDt: this.$route.query.taskDt,
      projectType
    };

    let needCertification = false;
    try {
      const {
        data: { data }
      } = await certification.queryProjectExtendCertification({
        projectId: id
      });
      needCertification = data === 1;
    } catch (error) {
      console.warn('get certification status', error);
    }

    const _config = deepClone(mainMap[projectStructureType]);
    const removeFields = [];
    const removeSearchs = [];
    if (projectType === 19) {
      // 协定服务需要删除的字段
      removeFields.push(
        ...[
          '项目结算单价（不含税）',
          '预计项目结算金额（不含税）',
          '终端结算单价',
          '预计终端结算金额',
          '预采购时间',
          '预采购任务量',
          '剩余预采购任务量',
          '预采购金额（含税）'
        ]
      );
    }
    if (projectStructureType === 2) {
      // 园区个体需要删除的字段
      removeFields.push(...['职业认证']);
    }
    if (!this.$checkNeedUserTag(this.$store.state.homeProject)) {
      // 特定情况需要删除人员标签
      removeFields.push(...['人员标签']);
      removeSearchs.push(...['人员标签']);
    }
    if (!needCertification) {
      // 未开启资质审核，删除对应字段
      removeFields.push(...['资质审核状态']);
      removeSearchs.push(...['资质审核状态']);
    }
    const dealConfig = (arr, rmArr) => {
      rmArr.length > 0 &&
        rmArr.forEach(rmLabel => {
          arr.forEach((obj, index) => {
            if (rmLabel === obj.label) {
              arr.splice(index, 1);
            }
          });
        });
    };
    const homeProject = this.$store.state.homeProject;
    const { fileUpSource, fileUpMode, payPassagewayCode } = homeProject;
    if (!payPassagewayCode) {
      // 只有工具payPassagewayCode为null，工具不展示故要删除支付通道搜索
      removeSearchs.push(...['支付通道']);
    }
    dealConfig(_config[0].childMenu[0].fields, removeFields);
    dealConfig(_config[0].childMenu[0].search, removeSearchs);
    _config[0].childMenu[0].fields.forEach(item => {
      if (item.prop === 'openStatus' && payPassagewayCode) {
        item.label += `(${this.BANK_MAPPING[payPassagewayCode].label})`;
      }
    });

    try {
      if (needCertification) {
        const oldList = _config[0].childMenu[0].list;
        _config[0].childMenu[0].list = async (...args) => {
          const res = await oldList(...args);
          try {
            const count = res.data.data.remarkMap.certificationOssAuditPass;
            if (count > 0) {
              this.needCertificationMsg(count);
            } else {
              this.ossRejectMsg();
            }
          } catch (error) {
            console.warn('get oss audit reject error', error);
          }
          return res;
        };
      }
    } catch (error) {
      console.warn('reset list error', error);
    }
    this.config = _config;

    // 选择上传来源为【我方上传-以活动形式上传】【双方共同上传】项目人员列表列表显示特殊tip
    const isEntry = [+fileUpSource, +fileUpMode].join(',');
    const listTipsShow = ['1,1', '3,1'].includes(isEntry) && projectType === 19;

    //因为上传来源是活动形式上传的所以【名单操作】被隐藏需要告知
    listTipsShow &&
      setTimeout(() => {
        this.$refs.tableRender.tips =
          '暂无数据，该项目的项目人员需在任务记录创建活动后添加';
      });
    this.tableKey += 1;
  },
  beforeDestroy() {
    Object.values(this.messages).forEach(
      message =>
        message &&
        typeof message.close === 'function' &&
        (message.autoClose = true) &&
        message.close()
    );
    this.messages = null;
  }
};
</script>

<style scoped lang="scss">
.project-personnel-inside-list {
  margin-top: 10px;
  &__tip {
    background: url('http://yiyang.oss-cn-beijing.aliyuncs.com/WEB/img/tag.png')
      no-repeat;
    min-width: 160px;
    padding: 0 30px;
    background-size: cover;
    height: 30px;
    color: #fff;
    line-height: 30px;
    position: absolute;
    top: 7px;
    right: 8px;
  }
}
</style>

<style lang="scss">
.project-personnel-inside-list__message .el-message__closeBtn {
  right: 6px;
  font-size: 20px;
}
</style>
